import '../../../common/dashboard/filters/filter.js.coffee'

Namespace 'CustomerVisualMode.Filters'

class CustomerVisualMode.Filters.TicketAttributesFilter extends Common.Dashboard.Filters.Filter
  @FILTER_TYPE: 'ticket_attributes'
  removable: true

  constructor: ({values, possibleValues}) ->
    super({values})
    @possibleValues = possibleValues

  getFilterType: ->
    CustomerVisualMode.Filters.TicketAttributesFilter.FILTER_TYPE

  toJSON: ->
    json = {}
    fixedStringValues = @_fixedStringValuesToJSON()
    hierarchicalTagsValues = @_hierarchicalTagsValuesToJSON()
    fixedStringFilterType = CustomerVisualMode.Filters.FixedStringAttributeFilter.FILTER_TYPE
    hierarchicalTagsFilterType = CustomerVisualMode.Filters.HierarchicalTagsAttributeFilter.FILTER_TYPE
    json["#{fixedStringFilterType}"] = fixedStringValues if Object.keys(fixedStringValues).length != 0
    json["#{hierarchicalTagsFilterType}"] = hierarchicalTagsValues if Object.keys(hierarchicalTagsValues).length != 0
    json

  _valuesToJSON: =>
    @values || []

  _fixedStringValuesToJSON: =>
    @_ticketAttributesValuesToJson((attribute) -> attribute.isFixedString())

  _hierarchicalTagsValuesToJSON: =>
    @_ticketAttributesValuesToJson((attribute) -> attribute.isHierarchicalTags())

  _ticketAttributesValuesToJson: (callback) =>
    attributes = @possibleValues
      .filter((attribute) -> callback(attribute))
      .map((attribute) -> attribute.get('code'))
    keysToBeIncluded = Object.keys(@values).filter((attribute) -> attributes.includes(attribute))
    _.assign({}, ("#{attribute}": @values[attribute] for attribute in keysToBeIncluded)...)

  getValues: =>
    [name: JSON.stringify(@values)]

  removeAttribute: (attributeCode) =>
    @values = _.omit(@values, attributeCode)

  removeAttributeValue: (attributeCode, value) =>
    values = @values[attributeCode]
    values = _.without(values, value.name)
    return @removeAttribute(attributeCode) if _.isEmpty(values)
    @values[attributeCode] = values

  isEmpty: =>
    _.isEmpty(@values)

  appliedAttributeCodes: =>
    _.keys(@values)

  removeFromCompositeFilter: (compositeFilter, attributeCode) =>
    filter = compositeFilter.filterWithType(@getFilterType())
    filter.removeAttribute(attributeCode)
    compositeFilter.removeFilter(filter) if filter.isEmpty()

  removeValueFromCompositeFilter: (compositeFilter, attributeCode, value) =>
    filter = compositeFilter.filterWithType(@getFilterType())
    filter.removeAttributeValue(attributeCode, value)
    compositeFilter.removeFilter(filter) if filter.isEmpty()
